import { SET_GENERAL_SETTING, GENERAL_SETTING_REQUEST, GENERAL_SETTING_REQUEST_FAILURE, SET_RELOAD_SETTINGS_PAYLOAD } from "../types";

const initialState = {
  generalSetting: {},
  loading: false,
  error: null,
  isLoaded: false,
  lastFetchedAt: null
};

const generalSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_SETTING_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case SET_GENERAL_SETTING: {
      return {
        ...state,
        generalSetting: { ...action.payload },
        loading: false,
        error: null
      }
    }
    case GENERAL_SETTING_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case SET_RELOAD_SETTINGS_PAYLOAD: {
      return {
        ...state,
        ...(action.payload || {})
      }
    }
    default:
      return state;
  }
};

export default generalSettingReducer;